"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Check_1 = require("../check/Check");
function isPdfExport(object) {
    return checkPdfExport(object).fulfilled;
}
exports.isPdfExport = isPdfExport;
function checkPdfExport(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return Check_1.check(object, Check_1.hasString("projectId"), Check_1.hasBoolean("exportAll"), Check_1.hasArray("messages", Check_1.isString()), Check_1.hasString("userId"), Check_1.hasString("docType").optional().nullable()).withOptions(options).explain();
}
exports.checkPdfExport = checkPdfExport;
//# sourceMappingURL=PdfExport.js.map